import React from 'react';
import { kitTestimonials } from '../data/content';
import { TestimonialCard } from './TestimonialCard';
export function MoreTestimonials() {
  return <section aria-labelledby="mas-testimonios-titulo" className="w-full bg-cream py-14 sm:py-20" data-id="element-177" data-mp="20fyo04qodgoc">
      <div className="mx-auto max-w-6xl px-5" data-id="element-178" data-mp="25b4bh7zq73ej">
        <h2 id="mas-testimonios-titulo" className="text-center font-display text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-179" data-mp="2a6tbtdjkkobw">
          ❤️ Lo que dicen quienes tienen el Kit Inclusión
        </h2>

        <div className="mt-9 grid gap-5 md:grid-cols-3" data-id="element-180" data-mp="1hjfnu4xun33x">
          {kitTestimonials.map(testimonial => <TestimonialCard key={testimonial.name + testimonial.meta} testimonial={testimonial} layout="nameFirst" data-id="element-181" data-mp="1mkd4ue74hr3u" />)}
        </div>
      </div>
    </section>;
}